import Onskeliste from "./Onskeliste";

export default Onskeliste;
